var map = {
	"./_base-button.vue": "3aCq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "COQt";


//////////////////
// WEBPACK FOOTER
// ./src/components/globals nonrecursive _base-[\w-]+\.vue$
// module id = COQt
// module chunks = 1